var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 131H16V381H496V131Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 116H16V131H496V116Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V116H496V16Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 396H16V381H496V396Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V396H496V496Z",
    fill: "#2980B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 255.664C109.928 203.756 155.167 162.107 210.407 162.638C265.648 163.168 309.972 205.677 309.407 257.584C308.843 309.492 263.604 351.141 208.363 350.61C153.521 350.084 109.358 308.159 109.358 256.624",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.584 337.609L210.945 295.455L151.424 339.345L174.322 273.403L114.187 230.358L183.977 231.757L206.333 161.264L226.568 228.071L300.52 227.549L243.235 267.439L266.584 337.609Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/KP.ac6855669418d4f404ace6116cfd7762.svg";
export { ForwardRef as ReactComponent };